export default __webpack_public_path__ + "static/media/5e4c51e317e12d83d9b3a65e2b39e44e.svg";